import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const MainWrapper = styled.main`
  & > section {
    max-width: ${themeGet('document.maxWidth')};
    margin: 0 auto 2.5rem 0; /*modified for inter-section padding based on homepage design */
  }
  &.main_msie {
  }
  &.page_404 {
   min-height: auto;
    position: relative;
    background: url('/images/background_404.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100%;
    & + footer {
      position: relative;
    }
    & > section.banner {
      height: auto;
      h1 {
        margin-top: 10rem;
        width: 750px;
      }
      .backgroundImage.gatsby-image-wrapper {
        overflow: hidden;
        position: absolute;
        z-index: -1;
      }
      .bannerBodyWrapper {
        position: absolute;
        z-index: 0;
        height: 800px;
        width: 100%;
        top: 0;
        left: 0;
      }
      .spinmaster-background-wrapper {
        height: calc(100% - 160px);
        min-height: 1000px !important;

        @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
          min-height: 560px !important;
        }
      }
      .backgroundImage.gatsby-image-wrapper img {
        object-fit: contain !important;
        object-position: right bottom !important;
        height: 75%;
        top: 15%;
        width: 75% !important;
        left: unset !important;
        right: 0 !important;
        max-width: 800px;
      }
    }

    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      background: none;
      & > section.banner {
        h1 {
          margin-top: 5rem;
        }
        .onlyMobile {
          max-height: 100%;
        }
        .foregroundImage.gatsby-image-wrapper {
          max-height: 100%;
          background: url('/images/background_404.png');
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: bottom;
          img {
            object-fit: contain !important;
            object-position: center bottom !important;
            top: unset;
            bottom: 0;
            max-height: 95%;
          }
        }
      }
    }
    @media only screen and (max-width: 413px) {
      & > section.banner .foregroundImage.gatsby-image-wrapper img {
        max-height: 85%;
      }
    }
  }
  &.page_home {
    section.banner.bannerLeft {
      .spinmaster-background-wrapper {
        .onlyDesktop {
          .backgroundImage {
            img {
              object-position: left center !important;
            }
          }
        }
      }
    }
    .cardsBlock {
      .card {
        h2 {
          font-size: 2.25rem;
          line-height: 2.5rem;
          margin-bottom: 1.5rem;
        }
        &.image-behind-text {
          h2 {
            font-size: 2.8125rem;
            line-height: 3.4375rem;
          }
        }
      }
    }
    @media only screen and (max-width: 815px) {
      .cardsBlock {
        .card {
          h2 {
            margin-bottom: 1.25rem;
            font-size: 1.875rem;
            line-height: 2.1875rem;
          }
          p {
            font-size: 1rem;
            line-height: 1.625rem;
          }
        }
        .card.image-behind-text {
          h2 {
            font-size: 1.875rem;
            line-height: 2.1875rem;
          }
          p {
            font-size: 1rem;
            line-height: 1.625rem;
          }
        }
      }
      .banner {
        .spinmaster-background-wrapper {
          .bannerDescription {
            padding-right: 1rem;
            p {
              font-size: 1rem;
              line-height: 1.625rem;
            }
          }
          .bannerBodyWrapper {
            h2 {
              font-size: 1.875rem;
              line-height: 2.1875rem;
            }
          }
        }
      }
    }
  }
  &.hasScrolled {
    & > .subnavigation {
      transition: all 0.1s ease-in;
      z-index: 110;
      background: white;
      top: 0;
    }

    @media only screen and (min-width: Calc(${themeGet(
        'breakpoints.lg',
      )} + 1px)) {
      & .subnavigation {
        top: 0;
        background: white;
      }
    }
  }
`;
